module.exports = __webpack_public_path__ + "img/video-file.78fe068a.svg";